import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '../config'


import Init from '../views/Init'
import Hello from '../views/Hello'
import Index from '../views/Index'
import AboutDetail from '../views/AboutDetail'
import FlatIndex from '../views/flatindex'
import FlatIndexMobile2 from '../views/flatindexmobile2'
import FlatIndexMobile from '../views/flatindexmobile'
import AboutUs from '../views/AboutUs'
import AboutUsMobile from '../views/AboutUsMobile'
import HelpCenter from '../views/HelpCenter'
import HelpCenterMobile from '../views/HelpCenterMobile'
import Cooperate from '../views/Cooperate'
import CooperateMobile from '../views/CooperateMobile'
import DdGo from '../views/DdGo'
import Declare from '../views/Declare'
import Pdxy from '../views/Pdxy'

export default new Router({
    // mode: config.ENV==""?'history':null,
    // mode: 'history',
    routes: [
        // {
        //     path: '/',
        //     redirect: {
        //         name: redirectIndex
        //     }
        // },
        {
            path: '/index',
            name: 'index',
            component: Index
        }, {
            path: '/hello',
            name: 'hello',
            component: Hello
        }, {
            path: '/aboutdetail',
            name: 'aboutdetail',
            component: AboutDetail
        }, {
            path: '/flatindex',
            name: 'flatindex',
            component: FlatIndex
        }, {
            path: '/flatindexmobile2',
            name: 'flatindexmobile2',
            component: FlatIndexMobile2
        } ,{
            path: '/flatindexmobile',
            name: 'flatindexmobile',
            component: FlatIndexMobile
        } ,{
            path: '/aboutus',
            name: 'aboutus',
            component: AboutUs
        } ,{
            path: '/aboutusmobile',
            name: 'aboutusmobile',
            component: AboutUsMobile
        } ,{
            path: '/helpcenter',
            name: 'helpcenter',
            component: HelpCenter
        } ,{
            path: '/cooperate',
            name: 'cooperate',
            component: Cooperate
        },{
            path: '/helpcentermobile',
            name: 'helpcentermobile',
            component: HelpCenterMobile
        },{
            path: '/cooperatemobile',
            name: 'cooperatemobile',
            component: CooperateMobile
        },{
            path: '/ddgo',
            name: 'ddgo',
            component: DdGo
        }, {
            path: '/declare',
            name: 'declare',
            component: Declare
        }, {
            path: '/pdxy',
            name: 'pdxy',
            component: Pdxy
        }

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js